import React, { PureComponent } from 'react'
import { Pane, Dialog, Code } from 'evergreen-ui'
import { User } from '../../types';

interface Props {
    display: boolean
    user: User
    setDisplay: (a: boolean) => void

}

interface State {
    display: boolean
    user: User
}

export default class Integrations extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            display: this.props.display,
            user: this.props.user
        }
    }

    componentDidMount(){
        this.setState({
            display: this.props.display,
            user: this.props.user
        })
    }

    componentDidUpdate(oldProps: Props) {
        if (this.props === oldProps) { return }
        this.setState({
            display: this.props.display,
            user: this.props.user,
        })
    }

    render() {
        const { display, user } = this.state;

        return (
            <Dialog
                isShown={display}
                title="Integrations"
                hasFooter={false}
                onCloseComplete={() => { this.props.setDisplay(false)}}
                width={400}>
                <Pane display="flex"
                    alignItems="center"
                    flexDirection="column">
                    Zapier Secret key: <Code size={400}>{user.zapierKey}</Code>
                </Pane>
                <Pane
                    display="flex"
                    alignItems="center"
                    flexDirection="column"
                    marginTop={5}>
                    Please keep this key private as it can be used to create zaps on your behalf.
            </Pane>
            </Dialog>
        )
    }

}